var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41602 19.7563V4.22925C2.41602 3.74591 2.59727 3.323 2.95977 2.9605C3.32227 2.598 3.74518 2.41675 4.22852 2.41675H19.7556V4.22925H4.22852V19.7563H2.41602ZM6.04102 23.3813V7.85425C6.04102 7.37091 6.22227 6.948 6.58477 6.5855C6.94727 6.223 7.37018 6.04175 7.85352 6.04175H23.3806V7.85425H7.85352V23.3813H6.04102ZM24.7702 26.5834H11.4785C10.9952 26.5834 10.5723 26.4022 10.2098 26.0397C9.84727 25.6772 9.66602 25.2542 9.66602 24.7709V11.4792C9.66602 10.9959 9.84727 10.573 10.2098 10.2105C10.5723 9.848 10.9952 9.66675 11.4785 9.66675H24.7702C25.2535 9.66675 25.6764 9.848 26.0389 10.2105C26.4014 10.573 26.5827 10.9959 26.5827 11.4792V24.7709C26.5827 25.2542 26.4014 25.6772 26.0389 26.0397C25.6764 26.4022 25.2535 26.5834 24.7702 26.5834Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c284f666.svg";
export { ForwardRef as ReactComponent };